var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseImg',{staticClass:"product-thumbnail-img img-fluid",attrs:{"lazy-src":_vm.imageUrl,"alt":_vm.element.name,"loading":"lazy"}})}
var staticRenderFns = []

export { render, staticRenderFns }